import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';

import { DriverService } from '@app/services/driver.service';

interface ITableElement {
  label: string;
  value: string;
}

@Component({
  selector: 'app-driver-central-details-modal',
  templateUrl: './driver-central-details-modal.component.html',
  styleUrls: ['./driver-central-details-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatProgressSpinnerModule],
})
export class DriverCentralDetailsModalComponent implements OnInit {
  // Summary data
  formType: string = '';
  topic: string = '';
  coach: string = '';
  creationDate: string = '';
  formId: string = '';

  // Details data
  detailFields: ITableElement[] = [];
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DriverCentralDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private driverService: DriverService
  ) {}

  ngOnInit(): void {
    // Set summary data from dialog input
    if (this.data) {
      this.formType = this.data.formType || '';
      this.topic = this.data.topic || '';
      this.coach = this.data.coach || '';
      this.creationDate = this.data.creationDate || '';
      this.formId = this.data.formId || '';

      if (this.formId) {
        this.loadDetailData();
      }
    }
  }

  loadDetailData(): void {
    this.isLoading = true;

    // Call service to get detail data
    this.driverService.getDriverCoachingHistoryDetail(this.formId).subscribe({
      next: (response) => {
        if (response && response.length > 0) {
          const detailData = response[0];

          // Map fields to detail fields
          if (detailData.fields && detailData.fields.length > 0) {
            this.detailFields = detailData.fields.map((field: any) => ({
              label: field.fieldName,
              value: field.answer,
            }));
          }
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading detail data:', error);
        this.isLoading = false;
      },
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
